import React from 'react'

export default function Footer() {
  return (
    <div className='border-4 border-white bg-blue w-full pt-20 flex'>
        <span className='p-2 text-white josefin-font text-xs text-center w-full'>Kelly Hunter</span>
    </div>
  )
}
